<template>
  <input :id="field.name"
         :data-vv-as="field.description.replace(/\./g, '')"
         :name="field.name"
         class="form-control"
         v-currency
         :readonly="locked"
         v-validate="{required: required && !field.hide}"
         :value="value"
         @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['input'],

  setup(props, { emit }) {}
}
</script>



// WEBPACK FOOTER //
// CurrencyRender.vue?34dc4569